import { provideGlobalGridOptions } from 'ag-grid-community';

export const agGridEnterpriseConfig = {
    enabled: false,
    licenseKey: '',
};

export const agGridEnterpriseEnabled = agGridEnterpriseConfig.enabled;

export async function initializeAgGrid(): Promise<void> {
    provideGlobalGridOptions({ columnMenu: 'legacy' });

    if (!agGridEnterpriseEnabled) {
        return;
    }

    const licenseKey = agGridEnterpriseConfig.licenseKey.trim();
    if (!licenseKey) {
        throw new Error('AG Grid Enterprise is enabled but no license key is configured.');
    }

    const { LicenseManager } = await import('ag-grid-enterprise');
    LicenseManager.setLicenseKey(licenseKey);
}
